<template>
  <div class="income-details" ref="IncomeDetails">
    <div class="header">
      <TopBar :title="title" />
    </div>
    <div class="content contetn-1" v-if="loading">
      <van-loading size="35" />
    </div>
    <div class="content" :style="{ 'background': list.length === 0 ? 'transparent' : '' }" v-else>
      <div v-if="list.length > 0">
        <div class="card" v-for="(item, index) of list" :key="index">
          <div class="date">{{ getDate(item.registryTime) }}</div>
          <div class="nickName">{{ item.userName }}</div>
          <div class="status-1"> <span>{{ item.contribution }} {{$t("helpEarn.yuan")}}</span></div>
        </div>
      </div>
      <div v-else class="content-nodata">
        <van-image width="100" height="100" :src="nodataImg" />
      </div>
    </div>

  </div>
</template>

<script>
import { AccountsFriends } from '@/api/api.js';
import TopBar from '@/common/top-bar/index.vue'
import img from '@/assets/img/无数据.png'
export default {
  name: 'IncomeDetails',
  components: {
    TopBar
  },
  data() {
    return {
      title: this.$t("helpEarn.moneyDetail"),
      list: [],
      loading: true,
      nodataImg: img,
      pagebar: {
        currentPage: 1,
        pageSize: 30,
        totalPage: 0,
        totalSize: 0,
      }
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    getDate(item) {
      const dateStr = item.trim().split(" ")
      return dateStr[0]
    },
    initPage() {
      if (this.pagebar.currentPage>1&&this.list.length >= this.pagebar.totalSize) return
      const loginInfo = JSON.parse(localStorage.getItem('LOGIN_INFO'));
      const params = {
        id: loginInfo.id,
        userName: "",
        page: this.pagebar.currentPage,
        size: this.pagebar.pageSize
      }
      AccountsFriends(params).then(res => {
        if (res.code === 200) {
          setTimeout(() => {
            this.loading = false
          }, 1000)
          this.list = [...this.list, ...res.data.list];
          this.pagebar = res.data.pagebar;
          ++this.pagebar.currentPage
        } else {
          Notify({ type: 'danger', message: res.errors[0] });
        }
      })
    },
    handleScroll(e) {
      if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight) {
        this.initPage();
      }
    },
  },
  mounted() {
    this.initPage();
    this.$refs.IncomeDetails.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    this.$refs.IncomeDetails.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<style lang="stylus" scoped>
  /deep/.income-details{
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #F3F3F3;
    .header{
      margin-bottom: .4rem;
    }
    .content{
      background: #ffffff;
      padding: .4rem;
      height: 100%;
      .card{
        display: flex;
        justify-content :space-between;
        align-items:center;
        padding-bottom: .4rem;
        line-height:1rem;
        font-weight bold;
      }
      .content-nodata{
        display flex;
        justify-content center;
      }
    }

    .contetn-1{
      display flex;
      justify-content center
    }
  }

  .status-1{
    color:#409F53;
  }
  .status-2{
    color: #FF7532;
  }
</style>



// WEBPACK FOOTER //
// src/pages/incomeDetails/IncomeDetails.vue